export default __webpack_public_path__ + "static/media/step-bg5.6bb7b886.png";